"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { SpaceMd, SpaceXs, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../Analytics/index.js";
import { MarketingTypography } from "../../MarketingTypography/index.js";
import { AccordionSection } from "./AccordionSection/index.js";
import { createAccordionItemIcons } from "./AccordionSection/AccordionItemIcon/createAccordionItemIcons.js";
import { Container, HeaderContainer, AccordionSectionContainer } from "./styles.js";
const AccordionSetUI = ({
  header,
  accordion_set,
  isMultiAccordionOpen,
  bodyBackGroundColor,
  svgIconsMap = {},
  accordionContentEntries,
  colorConfigHashMap
}) => {
  const accordionItemIcons = Object.keys(
    svgIconsMap
  ).reduce((acc, key) => {
    acc[key] = createAccordionItemIcons(svgIconsMap[key]);
    return acc;
  }, {});
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          identifier: "accordion-set",
          type: "nav"
        },
        trackType: "navigation"
      },
      children: /* @__PURE__ */ jsxs(Container, { "data-testid": "AccordionSet", children: [
        /* @__PURE__ */ jsx(HeaderContainer, { children: header.map((headerObj) => {
          var _a, _b, _c;
          return /* @__PURE__ */ jsx(
            MarketingTypography,
            {
              color: ((_b = (_a = headerObj.markdown_text.color) == null ? void 0 : _a.text_color) == null ? void 0 : _b.hex) || ColorGray900,
              component: headerObj.markdown_text.select_semantics_type,
              isMarkdown: true,
              variant: headerObj.markdown_text.select_text_type,
              sx: {
                marginBottom: SpaceXs,
                "&:last-child": {
                  marginBottom: SpaceMd
                }
              },
              children: headerObj.markdown_text.markdown_text
            },
            (_c = headerObj.markdown_text._metadata) == null ? void 0 : _c.uid
          );
        }) }),
        /* @__PURE__ */ jsx(AccordionSectionContainer, { children: /* @__PURE__ */ jsx(
          AccordionSection,
          {
            content: accordion_set,
            icons: accordionItemIcons,
            accordionContentEntries,
            isMultiAccordionOpen,
            bodyBackgroundColor: bodyBackGroundColor,
            colorConfigHashMap
          }
        ) })
      ] })
    }
  );
};
export {
  AccordionSetUI
};
